// Compact human-readable number formatting (e.g. 1.2M, 3.4B, 2T).
export const shortNum = (val) => {
  const n = Number(val || 0);
  if (!Number.isFinite(n)) return '0';
  const abs = Math.abs(n);
  if (abs >= 1e12) return `${(n / 1e12).toFixed(1)}T`;
  if (abs >= 1e9) return `${(n / 1e9).toFixed(1)}B`;
  if (abs >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  if (abs >= 1e3) return `${(n / 1e3).toFixed(1)}K`;
  return n.toLocaleString();
};

// Convert wei-scale BigInt string to whole-token compact number (÷ 10^18).
export const shortWei = (weiStr) => {
  try {
    const wei = BigInt(weiStr || '0');
    const whole = wei / 10n ** 18n;
    return shortNum(whole.toString());
  } catch {
    return '0';
  }
};
